import * as React from "react";
import { Box, Link } from "@mui/material";

import logoUrl from "assets/logos/markaaz.svg";

const sx = {
  root: {
    minHeight: "80px",
    backgroundColor: "common.white",
    display: "flex",
    alignItems: "center",
    padding: "0 30px",
    gap: "25px"
  },

  spacer: {
    flexGrow: "1"
  }
};

export default function Header() {
  return (
    <Box sx={sx.root}>
      <Link href="http://markaaz.com/">
        <img width={157} height={40} src={logoUrl} alt="Markaaz Logo" />
      </Link>

      <Box sx={sx.spacer}></Box>
    </Box>
  );
}
